module.exports = __webpack_public_path__ + "static/media/image-3.ac82b02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-3.png
// module id = 253
// module chunks = 0